<div class="chamado-toast" role="alert">
  <span class="chamado-toast-icone" aria-hidden="true"><i class='bx bx-support'></i></span>

  <div class="chamado-toast-corpo">
    <span class="chamado-toast-frase" *ngIf="title">{{ title }}</span>
    <strong class="chamado-toast-titulo" *ngIf="message">{{ message }}</strong>
    <span class="chamado-toast-acao">Clique aqui para ver o chamado <i class='bx bx-right-arrow-alt'></i></span>
  </div>

  <button *ngIf="options.closeButton" type="button" class="chamado-toast-fechar"
          (click)="fechar($event)" title="Fechar" aria-label="Fechar">
    <i class='bx bx-x'></i>
  </button>
</div>
